import { IIconProps } from "@fluentui/react";
import { ErrorType } from "../../../models/HttpError";
import { Settlement } from "../../../models/Entities/Settlements/Settlement";

// stores
import * as SettlementStore from '../../../redux/middleware/SettlementMiddleware';

//State
import { AppState } from "../../../redux/reducers";

// models
import { SettlementStatusEnum } from "../../../models/Enums/SettlementStatusEnum";


interface IProps {
    SettlementId: number;
    NextStatusIsActionConfirmed: SettlementStatusEnum;
    disabled?: boolean;
}
  
interface ConnectedProps {
    isChangingStatus: boolean;
    StatusChangedSuccessfully: boolean;
    failOnStatusChange: boolean;
    error: ErrorType | undefined;
    Settlement: Settlement | undefined
}

interface DispatchProps {
    ChangeSettlementStatus: typeof SettlementStore.actionCreators.ChangeSettlementStatus;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {

   const CurrentSettlement = state.Settlement && state.Settlement.list ? state.Settlement.list.find((item: Settlement) => item.id === ownProps.SettlementId ) : undefined    

   return {
        isChangingStatus: CurrentSettlement?.isChangingStatus || false,
        StatusChangedSuccessfully: CurrentSettlement?.successChangingStatus || undefined,
        failOnStatusChange: CurrentSettlement?.failOnChangeStatus || false,
        error: CurrentSettlement?.ErrorChangingStatus || undefined,
        Settlement: CurrentSettlement
    }
};

export const mapDispatchToProps = {
...SettlementStore.actionCreators,
};


//#region Icons
export const PropertiesIcon: IIconProps = { iconName: 'DietPlanNotebook' };
export const AddIcon: IIconProps = { iconName: 'CirclePlus' };
export const EditIcon: IIconProps = { iconName: 'Edit' };
export const Exclude: IIconProps = { iconName: 'Share' };
export const Include: IIconProps = { iconName: 'Installation' };
export const ViewIcon: IIconProps = { iconName: 'View' };
export const VerifycationOk: IIconProps = { iconName: 'CheckMark' };
export const LinkContractIcon: IIconProps = { iconName: 'Link' };
export const ItemObservedIcon: IIconProps = { iconName: 'SkypeMessage' };

export function getTriggerTextButtonByStatus(status: SettlementStatusEnum): string {
    switch (status) {
        case SettlementStatusEnum.CANCELLED:
            return "Descartar Liquidación";
        case SettlementStatusEnum.CONFIRMED:
            return "Confirmar Liquidación";
        case SettlementStatusEnum.PAID:
            return "Reconfirmar Liquidación";
        case SettlementStatusEnum.FAIL:
            return "Marcar Liquidación como Fallida";
        case SettlementStatusEnum.FINISHED:
            return "Finalizar Liquidación";
        case SettlementStatusEnum.IN_PROGRESS:
            return "Iniciar Liquidación";
        case SettlementStatusEnum.REGISTERED:
            return "Registrar Liquidación";
        case SettlementStatusEnum.REJECTED:
            return "Rechazar Liquidación";
        default:
            return "Unknown Status";
    }
}

export function GetConfirmedActionButtonText(status: SettlementStatusEnum): string {
    switch (status) {
        case SettlementStatusEnum.CANCELLED:
            return "Descartar";
        case SettlementStatusEnum.CONFIRMED:
            return "Confirmar";
        case SettlementStatusEnum.PAID:
            return "Reconfirmar";
        case SettlementStatusEnum.FAIL:
            return "Marcar como Fallida";
        case SettlementStatusEnum.FINISHED:
            return "Finalizar";
        case SettlementStatusEnum.IN_PROGRESS:
            return "Iniciar";
        case SettlementStatusEnum.REGISTERED:
            return "Registrar";
        case SettlementStatusEnum.REJECTED:
            return "Rechazar";
        default:
            return "Unknown Status";
    }
}

export function isDestructiveAction(status: SettlementStatusEnum): boolean {
    return [
        SettlementStatusEnum.CANCELLED,
        SettlementStatusEnum.FAIL,
        SettlementStatusEnum.REJECTED,
    ].includes(status);
}

export function getTriggerButtonAppearance(status: SettlementStatusEnum): 'primary' | 'secondary' | 'outline' {
    if (isDestructiveAction(status)) return 'outline';
    if (status === SettlementStatusEnum.CONFIRMED || status === SettlementStatusEnum.FINISHED) return 'primary';
    return 'secondary';
}

export function getDescriptionIntent(status: SettlementStatusEnum): 'warning' | 'info' {
    return isDestructiveAction(status) ? 'warning' : 'info';
}

export function GetActionTitleText(status: SettlementStatusEnum): string {
    switch (status) {
        case SettlementStatusEnum.CANCELLED:
            return "¿Está seguro que desea descartar la liquidación?";
        case SettlementStatusEnum.CONFIRMED:
            return "¿Está seguro que desea confirmar la liquidación?";
        case SettlementStatusEnum.PAID:
            return "Reconfirmación de liquidación";
        case SettlementStatusEnum.FAIL:
            return "¿Está seguro que desea marcar la liquidación como fallida?";
        case SettlementStatusEnum.FINISHED:
            return "¿Está seguro que desea finalizar la liquidación?";
        case SettlementStatusEnum.IN_PROGRESS:
            return "¿Está seguro que desea iniciar la liquidación?";
        case SettlementStatusEnum.REGISTERED:
            return "¿Está seguro que desea registrar la liquidación?";
        case SettlementStatusEnum.REJECTED:
            return "¿Está seguro que desea rechazar la liquidación?";
        default:
            return "Unknown Status";
    }
}
export function GetActionDescriptionText(status: SettlementStatusEnum): string {
    switch (status) {
        case SettlementStatusEnum.CANCELLED:
            return "Esta cancelando la liquidación si confirma, la liquidación será descartada y en caso de tener pagos asociados, estos serán anulados, y los conceptos incluidos en la liquidación pasarán a estar en estado pendiente de liquidación.";
        case SettlementStatusEnum.CONFIRMED:
            return "Esta confirmando la liquidación si confirma, la liquidación será confirmada y se generarán los compromisos de pagos correspondientes, los conceptos incluidos en la liquidación pasarán a estar en estado pendiente de cobro.";
        case SettlementStatusEnum.PAID:
            return "Esta reconfirmando la liquidación si confirma, esto regenerara las dedudas correspondientes a la liquidación en caso de ser necesario.";
        case SettlementStatusEnum.FAIL:
            return "Esta marcando como fallida la liquidación si confirma, la liquidación será marcada como fallida y en caso de tener pagos asociados, estos serán anulados, y los conceptos incluidos en la liquidación pasarán a estar en estado pendiente de liquidación.";
        case SettlementStatusEnum.FINISHED:
            return "Esta finalizando la liquidación si confirma, la liquidación será finalizada y los conceptos incluidos en la liquidación pasarán a estar en estado Liquidado.";
        case SettlementStatusEnum.IN_PROGRESS:
            return "Esta iniciando la liquidación si confirma, la liquidación será iniciada";
        case SettlementStatusEnum.REGISTERED:
            return "Esta registrando la liquidación si confirma, la liquidación será registrada";
        case SettlementStatusEnum.REJECTED:
            return "Esta rechazando la liquidación si confirma, la liquidación será descartada y en caso de tener pagos asociados, estos serán anulados, y los conceptos incluidos en la liquidación pasarán a estar en estado pendiente de liquidación.";

        default:
            return "Unknown Status";
    }
}